import { RoundValueASTM } from './FuelMath';
import {MathFormula} from './Math'

export class SoxService{

    static response={
       SoxTextBox:""
    };
    
    ;
    static CalculateSox(config)
    {
        
        let bunkerqty=config.bunkerqty? parseFloat(config.bunkerqty):0;
        let sulphur= config.sulphur?parseFloat(config.sulphur):0;
        //let CDbl="134.345";
        //let RoundValueASTM="5";
        let SOxFactor = "0.02025";
        let result= ((parseFloat(sulphur)) * SOxFactor) * (parseFloat(bunkerqty))
        result = RoundValueASTM(result);
        return result?result:""
    }
}